module.exports = __webpack_public_path__ + "img/manual3-2.3ea2b8fd.png";